"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.UnstyledInkColorArary = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _clsx3 = _interopRequireDefault(require("clsx"));

var _excluded = ["classes", "colors", "value", "readOnly"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var styles = function styles() {
  return {
    root: {
      display: 'grid',
      gridTemplateColumns: 'repeat(7, minmax(45px, 1fr))'
    },
    swatch: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      lineHeight: '1rem',
      fontSize: '0.6rem',
      marginBottom: 20
    },
    circle: {
      borderRadius: '50%',
      position: 'relative',
      height: 40,
      width: 40,
      margin: '0px 7px 7px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    selected: {
      position: 'relative',
      border: '1px solid white',
      margin: 0,
      height: '90%',
      width: '90%',
      '&::after': {
        content: '""',
        position: 'absolute',
        top: 9,
        left: 14,
        width: 7,
        height: 14,
        border: 'solid white',
        borderWidth: '0px 4px 4px 0px',
        transform: 'rotate(45deg)',
        MsTransform: 'rotate(45deg)',
        WebkitTransform: 'rotate(45deg)'
      }
    },
    selectable: {
      cursor: 'pointer'
    }
  };
};

var UnstyledInkColorArary = function UnstyledInkColorArary(props) {
  var classes = props.classes,
      colors = props.colors,
      value = props.value,
      readOnly = props.readOnly,
      rest = _objectWithoutProperties(props, _excluded);

  var onSelect = function onSelect(val) {
    return function () {
      var i = value.indexOf(val);
      var newValue = value.slice();

      if (i < 0) {
        // not selected, add it
        newValue.push(val);
      } else {
        newValue = [].concat(_toConsumableArray(newValue.slice(0, i)), _toConsumableArray(newValue.slice(i + 1)));
      }

      return props.onChange(newValue);
    };
  };

  function swatch(color, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: color.value + index,
      onClick: readOnly ? function () {} : onSelect(color.value),
      className: (0, _clsx3["default"])(classes.swatch, _defineProperty({}, classes.selectable, !readOnly))
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.circle,
      style: {
        backgroundColor: color.hex
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx3["default"])(classes.circle, _defineProperty({}, classes.selected, value.includes(color.value)))
    })), /*#__PURE__*/_react["default"].createElement("label", null, color.text, color.light ? '*' : ''));
  }

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: classes.root
  }, rest), colors.map(swatch));
};

exports.UnstyledInkColorArary = UnstyledInkColorArary;
UnstyledInkColorArary.defaultProps = {
  classes: {},
  value: []
};
UnstyledInkColorArary.propTypes = {
  classes: _propTypes["default"].any,
  colors: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    value: _propTypes["default"].string,
    text: _propTypes["default"].string,
    hex: _propTypes["default"].string,
    light: _propTypes["default"].bool
  })).isRequired,
  readOnly: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  value: _propTypes["default"].array
};

var _default = (0, _reactJss["default"])(styles)(UnstyledInkColorArary);

exports["default"] = _default;